<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="searchform" v-model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="副词">
                  <el-input v-model="form.advWords"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="等级">
                  <el-input v-model="form.lev"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>
    <!-- 副词 -->
    <el-table :data="BrandList" v-loading="loading" :show-overflow-tooltip="true" border stripe style="width: 100%" height="500">      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="id" label="副词ID" show-overflow-tooltip min-width="110px"></el-table-column>
      <el-table-column prop="advWords" label="副词" min-width="90px"></el-table-column>
      <el-table-column prop="lev" label="等级" min-width="90px"></el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>
          <!-- 删除 -->
          <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="delBrand(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" v-if="false">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog title="新增评价副词" :visible.sync="dialogFormVisible" @close="addDilogClosed" width="500px" :close-on-click-modal="false">
      <el-form :model="addform" :rules="rules" ref="addformRef">
        <el-form-item label="副词" prop="advWords" :label-width="formLabelWidth">
          <el-input v-model="addform.advWords" autocomplete="on" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="等级" prop="lev" :label-width="formLabelWidth">
          <el-input v-model="addform.lev" autocomplete="on" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑评价副词" :visible.sync="editdialogFormVisible" width="500px" @close="editDilogClosed" :close-on-click-modal="false">
      <el-form :model="editform" :rules="rules" ref="editformRef">
        <el-form-item label="副词" prop="advWords" :label-width="formLabelWidth">
          <el-input v-model="editform.advWords" autocomplete="on" style="width:100%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="等级" prop="lev" :label-width="formLabelWidth">
          <el-input v-model="editform.lev" autocomplete="on" style="width:100%" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBrand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {// pagination
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,// current page
      total: 0,// total
      rules: {// rule
        advWords: [
          { required: true, message: '请输入副词', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
        ],
        lev: [
          { required: true, message: '请输入等级', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur', type: 'string' },
        ],
      },
      form: {},// form
      addform: {},// 新增
      editform: {},// edit
      dialogFormVisible: false,// 新增评价副词
      editdialogFormVisible: false,// 编辑评价副词
      formLabelWidth: '80px',// label
      BrandList: [],// 评价副词
      loading: true,
    }
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getBrandLists()
    },
    // page size
    handleSizeChange(val) {
      this.queryInfo.pagesize = val
      this.getRoleLists()
    },
    // current page
    handleCurrentChange(val) {
      this.queryInfo.pagenum = val
      this.getRoleLists()
    },
    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields()
    },
    // 编辑
    editDilogClosed() {
      this.$refs.editformRef.resetFields()
    },
    // 新增评价副词
    async addBrand() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return
        this.$http.post('addVocAdvword', this.addform)
          .then((response) => {
            this.$message.success('添加评价副词成功')
            this.dialogFormVisible = false
            this.getBrandLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },
    // 显示修改用户对话框
    async showEditDilog(row) {
      this.editform = Object.assign({}, row)
      this.editdialogFormVisible = true
    },
    // 保存编辑评价副词信息
    saveBrand() {
      this.$refs.editformRef.validate(async (valid) => {
        if (!valid) return
        this.$http.post('editVocAdvword', this.editform)
          .then((response) => {
            const res = response.data
            this.$message.success('编辑成功')
            this.editdialogFormVisible = false
            this.getBrandLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },
    // 删除评价副词
    async delBrand(brdid) {
      const confirmResult = await this.$confirm('此操作将永久删除该评价副词, 是否继续?', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      // 确认删除
      if (confirmResult == 'confirm') {
        await this.$http.post('delVocAdvword/' + brdid)
          .then((response) => {
            const res = response.data
            this.$message.success('删除成功')
            this.getBrandLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
    // 获取评价副词
    async getBrandLists() {
      let data = {
        id: ''
      }
      this.loading = true
      await this.$http.post('getVocAdvword', data)
        .then((response) => {
          const res = response.data
          this.BrandList = res.data
          this.total = res.data.total
          this.currentPage = res.data.current_page
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          return this.$message.error(error.response.data.message)
        })
    },
  },
  created() {
    this.getBrandLists()
  },
}
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/voc/adverb.vue